module.exports = __webpack_public_path__ + "static/happy-65cdda82efea01f619bb127390fb8e8e.png";